var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFunnel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.337 0C.755 0 .32.208.117.586-.09.964-.022 1.43.306 1.9L5.115 8.41a.37.37 0 01.019.075l-.004 2.297c0 .289.132.633.32.822l2.326 2.137c.168.171.338.258.504.258.289 0 .58-.279.58-.901v-4.61c.001-.017.013-.063.019-.076l4.814-6.514c.328-.47.397-.935.193-1.313C13.68.208 13.247 0 12.665 0H1.33",
    fill: "#223762"
  })));
}

export default SvgFunnel;